import {ModuleComponent} from "../../js/module-component";
import {GvfService} from "../../../gvf/js/gvf-service";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";

export class ModBlogPostList extends ModuleComponent {

    ready() {
        super.ready();

        const categoryItems = document.querySelectorAll(this.scope + "__filter-category");
        const postLimit = this.$root.data("limit");

        categoryItems.forEach(item => {
            item.addEventListener("click", function () {
                categoryItems.forEach(categoryItem => {
                    categoryItem.classList.remove("active");
                });
                const filterId = item.getAttribute('data-category');
                GvfService.endpoint(
                    '/web/blog-post/render-blog-post-by-filter',
                    {blogCategoryId:filterId,postLimit:postLimit}
                ).then((resp) => {

                    if (resp.html) {
                        const contentDiv = document.getElementById('blog');
                        contentDiv.innerHTML = resp.html;
                        GvfUiService.init($(resp.html));
                    }
                });
                item.classList.add("active");
            });
        });

    }
}

